// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mediaAudio {
  width: 100%;
  border-radius: 15px;
  margin: 10px 0;
  background: #fff;
}

.mediaAudio.active {
  position: sticky;
  top: 0;
  z-index: 1;
}

.mediaVideo {
  width: 100%;
  background: #666;
  border: 1px solid #333;
  box-sizing: border-box;
  border-radius: 5px;
}

.mediaMissing {
  background: #333;
  color: #fff;
  padding: 12px;
  border-radius: 15px;
  margin: 3px 0;
}

.mediaImage {
  max-width: 100%;
}

.mediaAudioControls {
  display: flex;
  justify-content: end;
  gap: 10px;
  background: #000a;
  padding: 5px 10px;
  border-radius: 13px;
  color: #fff;
  align-items: center;
  transition: border-radius 200ms;
}

.mediaAudioControlsPlay:hover {
  color: #fff;
}

.mediaAudioControlsPlay {
  cursor: pointer;
  flex-shrink: 0;
  --icon-size: 20px;
  background: none;
  border: none;
  padding: 10px 15px;
  line-height: 0;
  color: #ddd;
  margin: -5px -10px;
}

.mediaAudioControlsDuration {
  flex-shrink: 0;
}

.mediaAudioControlsSpacer {
  flex: 1;
}

.mediaAudio {
  --wave-height: 100px;
  --scrubber-height: 3px;
}

.mediaAudioWave {
  position: relative;
  overflow: hidden;
  transition: height 200ms;
  height: calc(var(--wave-height) + var(--scrubber-height));
  line-height: 0;
  user-select: none;
}

.mediaAudio[data-load-requested=false] .mediaAudioWave {
  height: 0;
}

.mediaAudio[data-load-requested=true] .mediaAudioControls {
  border-radius: 0 0 13px 13px;
}

.mediaAudioScrubberHoverPosition,
.mediaAudioScrubberPlayPosition {
  top: 0;
  position: absolute;
  width: 2px;
  height: 100%;
  margin-left: -1px;
  left: -10px;
  pointer-events: none;
}

.mediaAudioScrubberHoverPosition {
  background-color: #000;
}

.mediaAudioScrubberPlayPosition {
  background-color: #fff;
  box-shadow: 0 0 3px #ce1ebb55, 0 0 3px #ce1ebb55;
}

.mediaAudioScrubberHorizontalLine {
  position: relative;
  height: var(--scrubber-height);
  background: #000;
}

.mediaAudioScrubberHorizontalLine div {
  height: 100%;
  background: #ff37e9;
  width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Media/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yDAAyD;EACzD,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,MAAM;EACN,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".mediaAudio {\n  width: 100%;\n  border-radius: 15px;\n  margin: 10px 0;\n  background: #fff;\n}\n\n.mediaAudio.active {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.mediaVideo {\n  width: 100%;\n  background: #666;\n  border: 1px solid #333;\n  box-sizing: border-box;\n  border-radius: 5px;\n}\n\n.mediaMissing {\n  background: #333;\n  color: #fff;\n  padding: 12px;\n  border-radius: 15px;\n  margin: 3px 0;\n}\n\n.mediaImage {\n  max-width: 100%;\n}\n\n.mediaAudioControls {\n  display: flex;\n  justify-content: end;\n  gap: 10px;\n  background: #000a;\n  padding: 5px 10px;\n  border-radius: 13px;\n  color: #fff;\n  align-items: center;\n  transition: border-radius 200ms;\n}\n\n.mediaAudioControlsPlay:hover {\n  color: #fff;\n}\n\n.mediaAudioControlsPlay {\n  cursor: pointer;\n  flex-shrink: 0;\n  --icon-size: 20px;\n  background: none;\n  border: none;\n  padding: 10px 15px;\n  line-height: 0;\n  color: #ddd;\n  margin: -5px -10px;\n}\n\n.mediaAudioControlsDuration {\n  flex-shrink: 0;\n}\n\n.mediaAudioControlsSpacer {\n  flex: 1;\n}\n\n.mediaAudio {\n  --wave-height: 100px;\n  --scrubber-height: 3px;\n}\n\n.mediaAudioWave {\n  position: relative;\n  overflow: hidden;\n  transition: height 200ms;\n  height: calc(var(--wave-height) + var(--scrubber-height));\n  line-height: 0;\n  user-select: none;\n}\n\n.mediaAudio[data-load-requested=false] .mediaAudioWave {\n  height: 0;\n}\n\n.mediaAudio[data-load-requested=true] .mediaAudioControls {\n  border-radius: 0 0 13px 13px;\n}\n\n.mediaAudioScrubberHoverPosition,\n.mediaAudioScrubberPlayPosition {\n  top: 0;\n  position: absolute;\n  width: 2px;\n  height: 100%;\n  margin-left: -1px;\n  left: -10px;\n  pointer-events: none;\n}\n\n.mediaAudioScrubberHoverPosition {\n  background-color: #000;\n}\n\n.mediaAudioScrubberPlayPosition {\n  background-color: #fff;\n  box-shadow: 0 0 3px #ce1ebb55, 0 0 3px #ce1ebb55;\n}\n\n.mediaAudioScrubberHorizontalLine {\n  position: relative;\n  height: var(--scrubber-height);\n  background: #000;\n}\n\n.mediaAudioScrubberHorizontalLine div {\n  height: 100%;\n  background: #ff37e9;\n  width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
